/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 操作タイプ（create: 作成、ai_execution: AI実行）
 */
export type JobsExecutionOperationType =
  (typeof JobsExecutionOperationType)[keyof typeof JobsExecutionOperationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobsExecutionOperationType = {
  create: 'create',
  ai_execution: 'ai_execution',
} as const;
